import { useEffect, useState, useCallback } from "react";
import anketaService from "../../services/anketa.service";
import SearchBar from "../../components/SearchBar";
import { Row, Col, Checkbox, Button, Space, Dropdown, Menu } from "antd";
import {
  CloseOutlined,
  FilterOutlined,
  TableOutlined,
  MenuOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import ConfirmDeleteModal from "../../components/ConfirmDeletModal";
import { useNavigate } from "react-router-dom";
import Background from "../../components/Background4";
import "./AnketaPage.css";
import "../Dokument/DokumentsPage.css";
import AnketaList from "./AnketaList";
import AnketaCards from "./AnketaCard";

const Anketa = () => {
  const [ankete, setAnkete] = useState([]);
  const [searchTitle, setSearchTitle] = useState("");
  const [selectedTip, setSelectedTip] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [selectedAnketaId, setSelectedAnketaId] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const navigate = useNavigate();
  const [sortCriteria, setSortCriteria] = useState("datumKreiranja");
  const [sortOrder, setSortOrder] = useState("asc");
  const [isListView, setListView] = useState(true);
  const showDeleteModal = (id) => {
    setSelectedAnketaId(id);
    setIsDeleteModalVisible(true);
  };

  const fetchAnkete = useCallback(async () => {
    try {
      const result = await anketaService.getAll();
      setAnkete(result.data);
    } catch (error) {}
  }, []);

  const sortAnkete = (ankete) => {
    return ankete.sort((a, b) => {
      let comparison = 0;
      if (sortCriteria === "datumKreiranja") {
        comparison = new Date(a.datumKreiranja) - new Date(b.datumKreiranja);
      } else if (sortCriteria === "naziv") {
        comparison = a.naziv.localeCompare(b.naziv);
      } else if (sortCriteria === "datumVazenja") {
        comparison = new Date(a.datumVazenja) - new Date(b.datumVazenja);
      }
      return sortOrder === "asc" ? comparison : -comparison;
    });
  };

  useEffect(() => {
    fetchAnkete();
  }, [fetchAnkete]);

  const tipOptions = [
    { label: "Javna", value: "JAVNA" },
    { label: "Zaštićena", value: "ZASTICENA" },
  ];

  const statusOptions = [
    { label: "Aktivna", value: "AKTIVNA" },
    { label: "Neaktivna", value: "NEAKTIVNA" },
  ];

  const handleResetFilters = () => {
    setSelectedTip([]);
    setSelectedStatus([]);
    setIsFilterVisible(false);
  };

  const filtriraneAnkete = ankete.filter((anketa) => {
    return (
      (!searchTitle ||
        anketa.naziv.toLowerCase().includes(searchTitle.toLowerCase())) &&
      (selectedTip.length === 0 || selectedTip.includes(anketa.tip)) &&
      (selectedStatus.length === 0 ||
        selectedStatus.includes(anketa.statusAnkete))
    );
  });

  const sortedAnkete = sortAnkete([...filtriraneAnkete]);

  const sortMenu = (
    <Menu onClick={(e) => setSortCriteria(e.key)}>
      <Menu.Item key="datumKreiranja">Datum kreiranja</Menu.Item>
      <Menu.Item key="datumVazenja">Datum važenja</Menu.Item>
      <Menu.Item key="naziv">Naziv</Menu.Item>
    </Menu>
  );

  const handleDeleteAnkete = async () => {
    if (selectedAnketaId === null) return;
    try {
      await anketaService.deleteAnketa(selectedAnketaId);
      setAnkete((prev) =>
        prev.filter((anketa) => anketa.id !== selectedAnketaId)
      );
    } catch (error) {
    } finally {
      setIsDeleteModalVisible(false);
      setSelectedAnketaId(null);
    }
  };

  return (
    <div>
      <Background />
      <div className="docs-border" style={{ position: "relative" }}>
        <div className="docs-container">
          <Row justify="center" align="middle" style={{ width: "90%" }}>
            <Col span={24}>
              <div className="page-title-and-search">
                <h1 className="page-title">Ankete</h1>
                <SearchBar
                  searchTitle={searchTitle}
                  setSearchTitle={setSearchTitle}
                />
              </div>
            </Col>
          </Row>

          <div className="AddButton-HeaderButton">
            <Row style={{ width: "100%" }}>
              <Col span={24} className="col-flex-end">
                <Button
                  type="primary"
                  icon={<FilterOutlined />}
                  onClick={() => setIsFilterVisible(!isFilterVisible)}
                >
                  {isFilterVisible ? "Sakrij filter" : "Filter"}
                </Button>

                <Button
                  type="primary"
                  onClick={() => navigate("/zaposleni/dodaj-anketu")}
                >
                  Dodaj novu anketu
                </Button>
              </Col>
            </Row>
            <Row style={{ width: "100%" }}>
              <Col
                span={24}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Space>
                  <Button
                    icon={isListView ? <TableOutlined /> : <MenuOutlined />}
                    onClick={() => setListView(!isListView)}
                  />
                  <Button
                    onClick={() =>
                      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                    }
                  >
                    {sortOrder === "asc" ? <UpOutlined /> : <DownOutlined />}
                  </Button>
                  <Dropdown overlay={sortMenu} trigger={["click"]}>
                    <Button>
                      Sortiraj
                      <DownOutlined />
                    </Button>
                  </Dropdown>
                </Space>
              </Col>
            </Row>
          </div>

          <div className="dokument-list-div">
            {isListView ? (
              <AnketaList
                ankete={sortedAnkete}
                onDeleteClick={showDeleteModal}
                setAnkete={setAnkete}
              />
            ) : (
              <AnketaCards
                ankete={sortedAnkete}
                onDeleteClick={showDeleteModal}
                setAnkete={setAnkete}
              />
            )}
          </div>
          <ConfirmDeleteModal
            visible={isDeleteModalVisible}
            onConfirm={handleDeleteAnkete}
            onCancel={() => setIsDeleteModalVisible(false)}
          />
        </div>

        <div className={`filter-panel ${isFilterVisible ? "visible" : ""}`}>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={() => setIsFilterVisible(false)}
            className="filter-close-button"
          />
          <h3 style={{ marginTop: "20px" }}>Filteri</h3>
          <h4>Tip ankete</h4>
          <Checkbox.Group
            options={tipOptions}
            value={selectedTip}
            onChange={setSelectedTip}
          />
          <h4 style={{ marginTop: "10px" }}>Status</h4>
          <Checkbox.Group
            options={statusOptions}
            value={selectedStatus}
            onChange={setSelectedStatus}
          />
          <Button style={{ marginTop: "20px" }} onClick={handleResetFilters}>
            Poništi filtere
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Anketa;
